import { render, staticRenderFns } from "./team.vue?vue&type=template&id=3a3bce7a&"
import script from "./team.vue?vue&type=script&lang=ts&"
export * from "./team.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports